import { connect, ConnectedProps } from 'react-redux'
import ModalCreateEdit from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import ProductCategories from '../../../../../../../baseComponents/Product/ProductCategories'
import { OnChangeMainCategoryTy } from '../../../../../../../baseComponents/Product/ProductCategories/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useModalCreateProductLogic from '../../../../../../../utils/hooks/product/useModalCreateProductLogic'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import locations from '../../../../../../../utils/globals/locations'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'
import { GroupVatPayload } from '../../../../../../../utils/reducers/globals/groupVats'
import { ModifiedCreateProductModelType } from '../../../../../../../specificComponents/Product/types'
import useModalCreateProductSpecificPricesLogic from '../../../../../../../utils/hooks/product/useModalCreateProductSpecificPricesLogic'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import NewProductSpecificPricesTable from '../../../../../../../specificComponents/Product/NewProductSpecificPricesTable'


interface ModalCreateServiceProps extends ModalEditComponentProps {
    customLocation?: string
}

const ModalCreateService: React.FC<ModalCreateServiceProps & ReduxModalCreateService> = ({ userPermissions, allRowData, onSubmit, groupVats, customLocation, ...rest }) => {
    const { handleOnSubmit, handleOnError, onChangeMain, reference, setReference } = useModalCreateProductLogic({ customLocation: customLocation || locations.services })
    const { t } = useTwinTranslation()
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: null, fieldsToLang: ['name'], keyValue: 'LangId' })
    const { dataPrices, setDataPrices, beforeSubmitAddSpecificPrices } = useModalCreateProductSpecificPricesLogic({})
    const fields: FormRender<ModifiedCreateProductModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang,
                    required: true
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'nameLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    name: 'reference',
                    label: t('reference', 'referencia'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    value: reference,
                    onChange: (value) => setReference(value)
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    required: true
                },
                {
                    name: 'categories',
                    component: 'Custom',
                    render: ModalProductCategories,
                    extraProps: { onChangeMain }
                },
                {
                    name: 'image',
                    label: t('imageProduct', 'Imagen del producto'),
                    component: 'ImageInput',
                },
                {
                    name: 'productType',
                    component: 'InputHidden',
                    value: 6
                },
            ]
        }
    ]

    return (<ModalCreateEdit fields={fields} url={'/api/app/product/createProduct'} beforeSubmit={beforeSubmitAddSpecificPrices} translations={{
        title: t('createService', 'Crear servicio'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} onSubmit={handleOnSubmit} onChangeError={handleOnError} {...rest} imagePath={['tmp']} className='notFlexAutoFormRender'>
        <div className='regular18 mb-20'>
            <TwinTrans transKey='prices'>Precios</TwinTrans>
        </div>
        <NewProductSpecificPricesTable dataPrices={dataPrices} setDataPrices={setDataPrices} />
    </ModalCreateEdit>)
}

interface ModalProductCategoriesProps {
    extraProps: {
        onChangeMain: OnChangeMainCategoryTy
    }
}

const ModalProductCategories: React.FC<ModalProductCategoriesProps> = ({ extraProps }) => {
    return (<ProductCategories productType={6} selectedCategories={[1]} className='createproduct_categories' onChangeMain={extraProps.onChangeMain} />)
}

const modalCreateServiceDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxModalCreateService = ConnectedProps<typeof modalCreateServiceConnect>
const mapModalCreateServiceConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const modalCreateServiceConnect = connect(mapModalCreateServiceConnector, modalCreateServiceDispatch)

const modalCreateServiceConnectLoading = withLoading(ModalCreateService, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])

const ModalCreateServiceConnect = modalCreateServiceConnect(modalCreateServiceConnectLoading)

export default ModalCreateServiceConnect